import $ from 'jquery';

export const encrypt = ($el) => {
    var $block = $el.closest('.form'),
        targetInputName = $el.attr('data-eway-encrypt-name'),
        $target = $block.find('[name="' + targetInputName + '"]'),
        currentValue = $el.val(),
        encryptedValue = currentValue;

    if (typeof(window.eCrypt) != 'undefined') {
        if(typeof(window.encryptKey) != 'undefined') {
            encryptedValue = window.eCrypt.encryptValue(currentValue, window.encryptKey);
        } else {
            console.log('Encryption Key is not available');
        }
    } else {
        console.log('eCrypt library cannot be found');
    }

    if (encryptedValue) {
        $target.val(encryptedValue);
    }
};
export const binds = () => {
    // ---------------- encrypt field
    $('#app').on('change.eway', '[data-eway-encrypt-name]', function () {
        encrypt($(this));
    });
};
